import { render, staticRenderFns } from "./info.vue?vue&type=template&id=6b6b7063&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=6b6b7063&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b7063",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b6b7063')) {
      api.createRecord('6b6b7063', component.options)
    } else {
      api.reload('6b6b7063', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=6b6b7063&scoped=true", function () {
      api.rerender('6b6b7063', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/retailer/product/info.vue"
export default component.exports